'use client'

import { useState } from 'react'
import { cn } from '../lib/cn'
import { trackEvent } from '../lib/analytics'

interface CTAButtonProps {
  children: React.ReactNode
  chipColor?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
  trackingLabel?: string
}

export function CTAButton({
  children,
  chipColor = '#C5ECAC',
  onClick,
  className,
  trackingLabel,
}: CTAButtonProps) {
  const [hovered, setHovered] = useState(false)

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (trackingLabel) trackEvent('click', 'button', trackingLabel)
    onClick?.(e)
  }

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={cn('inline-flex items-center gap-3 rounded-full border-none cursor-pointer', className)}
      style={{
        background: '#091410',
        color: '#faf9f5',
        fontFamily: 'var(--font-clash)',
        fontWeight: 500,
        fontSize: '16px',
        padding: '10px 10px 10px 28px',
        boxShadow: hovered
          ? '0 20px 40px rgba(9, 20, 16, 0.30)'
          : '0 14px 30px rgba(9, 20, 16, 0.24)',
        transform: hovered ? 'translateY(-3px)' : 'translateY(0)',
        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
      }}
    >
      {children}
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '34px',
          height: '34px',
          borderRadius: '9999px',
          color: '#091410',
          background: chipColor,
          transition: 'background 0.45s ease',
          flexShrink: 0,
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </span>
    </button>
  )
}
